import React, { useEffect } from 'react';
import { ArrowLeft, Mail, ShieldCheck } from 'lucide-react';

const CONTACT_EMAIL = 'info@commetriq.de';

const faqs = [
    {
        question: 'Wie verbinde ich ein Konto?',
        answer: 'Melde dich in Commetriq an und öffne Profil → Datenquellen. Wähle den gewünschten Anbieter und folge der jeweiligen Autorisierung.'
    },
    {
        question: 'Welche Daten kann Commetriq auswerten?',
        answer: 'Je nach angebundener Quelle können unter anderem Bestellungen, Gebühren, Zahlungen, Retouren, Bestand und Versanddaten in einer Übersicht zusammengeführt werden.'
    },
    {
        question: 'Wie funktioniert die Google-Ads-Verbindung?',
        answer: 'Du klickst in Commetriq auf „Mit Google Ads verbinden“, meldest dich bei Google an und gibst den Zugriff frei. Commetriq liest danach nur die Werbedaten, die für das Dashboard nötig sind, zum Beispiel Kampagnen, Kosten, Klicks und Conversions. Dein Google-Passwort wird nicht gespeichert.'
    },
    {
        question: 'Kann ich eine Verbindung wieder entfernen?',
        answer: 'Ja. Du kannst Verbindungen jederzeit in Commetriq entfernen und die Freigabe zusätzlich beim jeweiligen Anbieter widerrufen.'
    }
];

export default function SupportPage() {
    useEffect(() => {
        document.title = 'Hilfe & Support | commetriq';
    }, []);

    return (
        <main className="min-h-screen bg-[#f8f7f4] px-5 py-8 text-slate-950 sm:px-8 lg:px-12">
            <div className="mx-auto max-w-4xl">
                <a href="/" className="inline-flex items-center gap-2 text-sm font-semibold text-slate-600 transition hover:text-orange-600">
                    <ArrowLeft size={16} aria-hidden="true" />
                    Zurück zu commetriq
                </a>

                <section className="mt-12 rounded-[2rem] border border-slate-200 bg-white px-7 py-10 shadow-sm sm:px-12 sm:py-14">
                    <p className="text-sm font-bold uppercase tracking-[0.18em] text-orange-600">Support</p>
                    <h1 className="mt-4 max-w-2xl text-4xl font-semibold tracking-[-0.045em] sm:text-5xl">Hilfe zu Commetriq</h1>
                    <p className="mt-5 max-w-2xl text-base leading-8 text-slate-600 sm:text-lg">
                        Fragen zur Einrichtung, einer Datenquelle oder deinem Konto? Schreib uns – wir helfen dir direkt weiter.
                    </p>

                    <a href={`mailto:${CONTACT_EMAIL}`} className="mt-8 inline-flex items-center gap-3 rounded-xl bg-orange-600 px-5 py-3.5 text-sm font-bold text-white transition hover:bg-orange-700">
                        <Mail size={18} aria-hidden="true" />
                        {CONTACT_EMAIL}
                    </a>
                </section>

                <section className="mt-10">
                    <h2 className="text-2xl font-semibold tracking-[-0.03em]">Häufige Fragen</h2>
                    <div className="mt-5 divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white px-6 sm:px-8">
                        {faqs.map(({ question, answer }) => (
                            <article key={question} className="py-6">
                                <h3 className="text-base font-semibold">{question}</h3>
                                <p className="mt-2 max-w-3xl text-[15px] leading-7 text-slate-600">{answer}</p>
                            </article>
                        ))}
                    </div>
                </section>

                <section className="mt-10 flex gap-3 rounded-2xl border border-orange-100 bg-orange-50 px-6 py-5 text-sm leading-6 text-slate-700">
                    <ShieldCheck className="mt-0.5 shrink-0 text-orange-600" size={20} aria-hidden="true" />
                    <p>Kontodaten und Verbindungen werden nur für das jeweilige Unternehmen verarbeitet. Zugangsdaten oder Autorisierungen musst du uns nicht per E-Mail schicken.</p>
                </section>
            </div>
        </main>
    );
}
